
import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { JobSearchFormData } from '../JobSearchFormSchema';
import { KeywordsInput } from './advanced-options/KeywordsInput';

interface AdvancedOptionsAccordionProps {
  control: Control<JobSearchFormData>;
  errors: FieldErrors<JobSearchFormData>;
  isLoading: boolean;
}

export const AdvancedOptionsAccordion: React.FC<AdvancedOptionsAccordionProps> = ({
  control,
  errors,
  isLoading,
}) => {
  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="advanced-options">
        <AccordionTrigger className="text-lg font-semibold">Advanced Options</AccordionTrigger>
        <AccordionContent className="space-y-6 pt-4">
          <KeywordsInput
            control={control}
            errors={errors}
            isLoading={isLoading}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
